import { WSTable } from "@wingspanhq/fe-component-library";
import { Batch } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import { getColumns } from "./columns";

type Props = {
  batches: Batch[];
  loading?: boolean;
  onRowClick?: (batch: Batch) => void;
};

export const TablePayableImportBatches: React.FC<Props> = props => {
  const tableData = useMemo(
    () => props.batches.map(batch => ({ id: batch.id as string, data: batch })),
    [props.batches]
  );
  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<Batch>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      onRowClick={
        props.onRowClick
          ? rowItem => props.onRowClick?.(rowItem.data)
          : undefined
      }
    />
  );
};
